import { CardAction } from "@/shared/components/common/Card";
import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import { Button } from "@/shared/components/common/button";
import type { MinPriceRoom } from "@/types/services/hotel/apis/Detail";
import useCountRooms from "../useCountRooms";
import RoomCardCounter from "./RoomCardCounter";

interface RoomCardActionProps {
  room: MinPriceRoom;
  label: string;
  limitLabel: string;
}

export default function RoomCardAction({
  room,
  label,
  limitLabel,
}: RoomCardActionProps) {
  const limit = 4;
  const roomsProps = useCountRooms(room, limit);
  const { countRooms, currentRoomCount, totalRoomCount } = roomsProps;
  const handleSelectRoom = () => totalRoomCount < limit && countRooms(1);

  return (
    <CardAction>
      <Flex alignItems={"center"} gap={"2"}>
        <Flex alignItems={"center"} gap={"1"}>
          {currentRoomCount > 0 ? (
            <RoomCardCounter room={room} {...roomsProps} limit={limit} />
          ) : (
            <Button
              className={"rounded-full px-10 py-5 animate-fade-in"}
              onClick={handleSelectRoom}
              disabled={totalRoomCount === limit}
            >
              <Typography
                variant={"body1"}
                fontWeight={"medium"}
                className="text-background dark:text-foreground"
              >
                {totalRoomCount < limit ? label : limitLabel}
              </Typography>
            </Button>
          )}
        </Flex>
      </Flex>
    </CardAction>
  );
}
